var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.attendanceStatus)?_c('AttendanceStatusCard',{attrs:{"active":false,"attendanceStatus":_vm.attendanceStatus},on:{"click":_vm.handleOverTimeClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }